import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '~/javascript/components/locations/show.vue'

export default class extends Controller {
  static values = {
    locationId: String
  }

  connect() {
    this.vue = createApp(App, {
      locationId: this.locationIdValue
    })
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
